<template>
  <O3D>

    <!-- <IsoVisual :px="0" :pz="0" :py="0" :name="'_dill8l26f'"></IsoVisual> -->

    <O3D :px="ty * 1500" :key="ty" v-for="(type, ty) in cityItems.types">
      <!-- <O2DHTML :px="-1 * 1000" class="bg-white py-2 px-3 rounded-full text-xs">{{ type }}</O2DHTML> -->
      <O3D :key="lix + 'li'" v-for="(li, lix) in cityItems.list.filter(e => e.type === type && !e.isLand)">
        <IsoVisual :ry="pi" :pz="2000 * lix" :px="0" :py="0" :name="li.name"></IsoVisual>
      </O3D>
    </O3D>

    <!--
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'_dill8l26f'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Maras_0'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Maras_3_6'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Resque_2'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Umbrella'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_1'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_10'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_10_1'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_10_2'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_10_2_4'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_10_3'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_1_1'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_1_2'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_1_3'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_2'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_2_2'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_3'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_3_1'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_4'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_5'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_6'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_6_1'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_6_4'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_7'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_7_1'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_7_2'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_8'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_8_1'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_8_1_2'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_8_2'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_8_Gas_Station'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_9'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_9_1'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_9_2'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_9_2_3'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Block_9_3'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Cafe'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'House_10'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'House_19'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'House_1_15'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'House_21'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'House_2_2'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'House_3'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'House_3_2'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'House_4_2'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Muff_1_4'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'PArking'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Round_Building'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Shop_3'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Stadium'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Tower'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Tree_1_6'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Tree_4'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Gull_6'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Helicopter'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Landscape_1'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Mount'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'_dill8l26f'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Palm_0'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Containers_Ship_1'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Ship_2'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Streetlight_0'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'traffic_light_0'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'CAR_03_1'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Car_04'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Car_04_3'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Car_04_4'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'Car_08_7'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'_k1k4u9bf6'"></IsoVisual>
    <IsoVisual :px="100 * 10" :pz="0" :py="0" :name="'_vxnsflsdd'"></IsoVisual> -->

    <!-- <O3D v-show="false">{{ i = 0 }}</O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Bed'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Bed_1'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Bench_12'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Bench_2'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Bench_21'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Bench_25'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Bushes_10'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Bushes_15'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Bushes_3_2'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Bushes_3_4'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Bushes_3_6'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Containers_Ship_1'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Field_1'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Firtree_47'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Floor_4'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Gull_6'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'H'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Hosuse'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Hosuse_4'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'House'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'House_1'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'House_10'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'House_1_5'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'House_3_2'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'House_9'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Landscape_1'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Maras_0'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Maras_3_6'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Mount'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Muff'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Muff_2'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Palm_0'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :rx="pi * 0.5" :name="'Resque_2'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Road_1_10_7'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Road_1_11'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Road_1_18'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Road_3_1'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Round_Building_2'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Ship_2'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Shop'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Shop_2'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Skyscraper'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Skyscraper_2'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Skyscraper_3'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Slide'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Slide_3'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Streetlight_0'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Trash_2'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Tree_1'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Tree_2'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Tree_3_11_2'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Tree_3_7_0'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Tree_3_8_2'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'Umbrella'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'bUSH_3'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'bUSH_7'"></IsoVisual>
    </O3D>
    <O3D :pz="(i / 6) * 1000" :px="(i++ % 6) * 1000">
      <IsoVisual :name="'traffic_light_0'"></IsoVisual>
    </O3D> -->
  </O3D>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { CityItems } from './CityItems'
export default {
  mixins: [
    O3DG2
  ],
  data () {
    return {
      cityItems: new CityItems()
    }
  },
  methods: {
    async run () {
      console.log(this.cityItems)
    }
  },
  mounted () {
    this.run()
  }
}
</script>

<style>

</style>